<div class="relative w-[150px] h-[150px] hover:cursor-pointer">
  <div (mouseenter)="showEdit = true" (mouseleave)="showEdit = false"
       class="relative w-[150px] h-[150px] overflow-hidden bg-gray-100 rounded-full  z-10 border-white border-4">
    @if (showEdit) {
      <div
        (click)="openImageOptions(image)"
        class="absolute -left-4 -top-4 w-[180px] h-[180px] overflow-hidden bg-black bg-opacity-30 rounded-full z-20 border-white border-4">
        <div
          class="flex absolute h-[30px] w-[30px] rounded-full z-20 items-center justify-center right-[75px] bottom-[30px] bg-transparent">
          <fa-icon [icon]="faPen" class="flex text-white"></fa-icon>
        </div>
      </div>
    }
    @if (!image) {
      <div
        (click)="openImageOptions(image)"
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-400">
        <fa-icon [icon]="faBuilding" [size]="'5x'"></fa-icon>
      </div>
    }
    @if (image) {
      <img (click)="openImageOptions(image)" (error)="image = undefined" alt="img" class="z-10" src="{{image}}">
    }
    <input #imageInput (change)="uploadImage($event)" [disabled]="showOnly" accept="image/png, image/jpeg" type="file"
           hidden id="imageInput">
  </div>
</div>
